import { render, staticRenderFns } from "./ReportActiveuser.vue?vue&type=template&id=f61e84da&"
import script from "./ReportActiveuser.vue?vue&type=script&lang=js&"
export * from "./ReportActiveuser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports